import type {ComponentProps} from '@enonic/react-components'
import * as React from 'react'
import {Section, Container, Icon} from '../primitives'
import type {SnarveierData, SnarveiItem} from './SnarveierProcessor'

export const Snarveier = (props: ComponentProps) => {
    const {heading, items} = props.data as SnarveierData

    if (!items || items.length === 0) return null

    return (
        <Section>
            <Container>
                {heading && (
                    <h2 className="col-span-full mb-2 text-5xl text-blue-900">
                        {heading}
                    </h2>
                )}
                {items.map((item, index) => (
                    <SnarveiCard key={index} item={item} />
                ))}
            </Container>
        </Section>
    )
}

interface SnarveiCardProps {
    item: SnarveiItem
}

const SnarveiCard = ({item}: SnarveiCardProps) => {
    const externalAttrs = item.isExternal
        ? {target: '_blank', rel: 'noopener noreferrer'}
        : {}
    return (
        <article className="group relative col-span-full flex h-full flex-col justify-between gap-6 bg-blue-100 p-6 md:col-span-4 md:p-8">
            <div className="flex flex-col gap-2">
                <h3 className="text-2xl font-medium leading-snug text-blue-900 group-hover:underline">
                    <a
                        className="after:absolute after:inset-0 after:z-10 after:content-['']"
                        href={item.url}
                        {...externalAttrs}
                    >
                        {item.heading}
                    </a>
                </h3>
                {item.description && (
                    <p className="text-base leading-normal text-slate-900">
                        {item.description}
                    </p>
                )}
            </div>
            <span
                aria-hidden="true"
                className="inline-flex h-12 w-12 items-center justify-center bg-blue-500 text-black transition-colors group-hover:bg-peach-500"
            >
                <Icon name={item.isExternal ? 'north_east' : 'arrow_forward'} size={24} />
            </span>
        </article>
    )
}
